import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import {
    SET_SERVER_STATUS,
    SET_SERVER_STATUS_LOADING,
} from './types';

export const setServerStatus = (status: string, msg: string) => {
    return {
        type : SET_SERVER_STATUS,
        payload : { status, msg }
    }
}

export const setServerStatusLoading = (loading: boolean) => {
    return {
        type: SET_SERVER_STATUS_LOADING,
        payload: loading
    }
}

export const fetchServerStatus = () => async (dispatch: any) => {
    dispatch(setServerStatusLoading(true));
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + '/api/portal/status/' + process.env.REACT_APP_CLIENT_ID,
            AxiosConfig.configValue("min")
        );
        dispatch(setServerStatus(res.data.status, res.data.msg));
    } catch (err) {
        dispatch(setServerStatus('Error', 'Error Receiving Status'));
    } finally {
        dispatch(setServerStatusLoading(false));
    }
}

export const startStatusPoller = () => (dispatch: any) => {
    //console.log('[ServerStatus] startStatusPoller called');
    dispatch(fetchServerStatus());
    let interval: ReturnType<typeof setInterval>

    const start = () => {
        //console.log('[ServerStatus] start() called, setting interval');
        interval = setInterval(() => {
            //console.log('[ServerStatus] interval fired');
            dispatch(fetchServerStatus());
        }, 1000 * 60);
    }

    const stop = () => {
        //console.log('[ServerStatus] stop() called, clearing interval:', interval);
        clearInterval(interval);
    }

    //start the first interval
    start();

    //visibility listener
    const onVisibilityChange = () => {
        //console.log('[ServerStatus] visibilitychange fired, document.hidden:', document.hidden);
        if(document.hidden) {
            stop();
        } else {
            dispatch(fetchServerStatus());
            stop();
            start();
        }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    //network listeners
    const onOffline = () => {
        dispatch(setServerStatus('Offline', 'Offline'));
    };
    window.addEventListener('offline', onOffline);

    const onOnline = () => {
        dispatch(fetchServerStatus());
    };
    window.addEventListener('online', onOnline);

    return () => {
        stop();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('offline', onOffline);
        window.removeEventListener('online', onOnline);
    }
}
